import EventBus from './Event';

class Modal {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.modalName = this.$el.data('modal-name')
    this.$modalTrigger = $(document.body).find(`[data-modal-trigger="${this.modalName}"]`);
    this.$modalClose = this.$el.find('[data-modal-close]');

    this.onClickTrigger = this.onClickTrigger.bind(this);
    this.onClickClose = this.onClickClose.bind(this);

    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];

    console.log('modal instantiated: ', this.modalName);
  }

  bindEvents() {
    this.$modalTrigger.on('click', this.onClickTrigger);
    this.$modalClose.on('click', this.onClickClose);

    // EventBus.on('modal:bind-trigger', this.onBindTrigger.bind(this));
  }

  onClickTrigger(e) {
    e.preventDefault();
    const $target = $(e.currentTarget);
    this.$el.addClass('open');

    if ($target.data('modal-section')) {
      const sectionName = $target.attr('data-modal-section');
      Modal.showInnerSection(this.modalName, sectionName);
    }
  }

  onClickClose(e) {
    e.preventDefault();
    this.$el.removeClass('open');
  }

  // onBindTrigger($trigger) {
  //   $trigger.on('click', this.onClickTrigger);
  // }

  static init() {
    $('[data-modal="root"]').each((i, el) => new Modal(el));
  }

  static open(modalName) {
    const $modal = $(document.body).find(`[data-modal-name="${modalName}"]`);
    $modal.addClass('open');
  }

  static close(modalName) {
    const $modal = $(document.body).find(`[data-modal-name="${modalName}"]`);
    $modal.removeClass('open');
  }

  static closeAll() {
    $('[data-modal="root"]').removeClass('open');
  }

  static updateInnerContent(modalName, selector, content) {
    const $modal = $(document.body).find(`[data-modal-name="${modalName}"]`);
    $modal.find(selector).prepend(content);
  }

  static getContentElement(modalName, selector) {
    const $modal = $(document.body).find(`[data-modal-name="${modalName}"]`);
    return $modal.find(selector);
  }

  static showInnerSection(modalName, sectionName) {
    console.log('sectionName: ', sectionName);
    const $modal = $(document.body).find(`[data-modal-name="${modalName}"]`);
    $modal.find(`[data-modal-section]`).hide();
    $modal.find(`[data-modal-section="${sectionName}"]`).show();
  }
}

Modal.init();

export default Modal;